import React, { useState, useEffect } from "react";
import useMediaQuery from "../../utils/media-query";

const ExpandableSection = ({
  heroBanner,
  children,
  defaultExpanded = false,
  disableCollapse = false,
  loading = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  const isMobile = useMediaQuery("(max-width: 768px)");

  useEffect(() => {
    if (disableCollapse) {
      setIsExpanded(true);
    }
  }, [disableCollapse]);

  if (loading) {
    return null;
  }

  const toggleExpanded = () => {
    if (!disableCollapse) {
      setIsExpanded(!isExpanded);
    }
  };

  return (
    <section className="bg-white rounded-xl shadow-lg overflow-hidden">
      <div className="relative isolate">
        <div
          className={`${
            isMobile && !disableCollapse ? "cursor-pointer" : ""
          } relative z-10`}
          onClick={isMobile ? toggleExpanded : undefined}
        >
          {heroBanner}
        </div>
        {!disableCollapse && (
          <button
            onClick={toggleExpanded}
            className="absolute top-1/2 right-3 md:right-4 transform -translate-y-1/2 z-30 bg-white/95 backdrop-blur-sm duration-300 border-2 border-[#805AED] shadow-lg rounded-full w-8 h-8 md:w-10 md:h-10 flex items-center justify-center hover:bg-white hover:scale-105 transition-all"
            aria-label="Toggle details"
            style={{ marginTop: "4px" }}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              className={`transform transition-transform duration-300 w-3.5 h-3.5 md:w-4 md:h-4 ${
                isExpanded ? "rotate-180" : ""
              }`}
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 4V20M12 20L5 13M12 20L19 13"
                stroke="#666"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        )}
      </div>

      {isExpanded && (
        <div className="w-full p-4 md:px-8 md:py-6 transition-all duration-300 ease-in-out">
          {children}
        </div>
      )}
    </section>
  );
};

export default ExpandableSection;
